import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ScrollContainerComponent from 'PointOfSale/modules/common/component/ScrollContainer';

const DIRECTION = {
  UP: -1,
  DOWN: 1,
};
class ScrollContainer extends Component {
  scrollRef = React.createRef();

  get hasScrollRef() {
    return Boolean(this.scrollRef && this.scrollRef.current);
  }

  scroll = (direction = DIRECTION.UP) => {
    if (this.hasScrollRef) {
      let scrollBy = this.props.scrollBy;
      if (this.props.paging) {
        scrollBy = this.scrollRef.current.clientHeight;
      }
      this.scrollRef.current.scrollBy(0, direction * scrollBy);
    }
  };

  onScrollUp = () => {
    if (this.props.onScrollUp) {
      this.props.onScrollUp();
    } else {
      this.scroll(DIRECTION.UP);
    }
  };
  onScrollDown = () => {
    if (this.props.onScrollDown) {
      this.props.onScrollDown();
    } else {
      this.scroll(DIRECTION.DOWN);
    }
  };

  render() {
    return (
      <ScrollContainerComponent
        scrollRef={this.scrollRef}
        onScrollUp={this.onScrollUp}
        onScrollDown={this.onScrollDown}
        {...this.props}
      />
    );
  }
}

ScrollContainer.propTypes = {
  enableScrollButtons: PropTypes.bool,
  height: PropTypes.string,
  mealTypesActions: PropTypes.shape({
    selectFoodItem: PropTypes.func,
  }),
  scrollBy: PropTypes.number,
  // determines whether to scroll down by the full height of the scroll container
  paging: PropTypes.bool,
};

ScrollContainer.defaultProps = {
  scrollBy: 25,
  paging: false,
};

export default ScrollContainer;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/container/ScrollContainer.js